// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".submit-table[data-v-e5b640d0] {\n  width: 90%;\n  margin-left: 5%;\n  margin-top: 1.875rem;\n  margin-bottom: 3.125rem;\n  height: 31.25rem;\n  overflow: auto;\n}", ""]);
// Exports
module.exports = exports;
